import { render, staticRenderFns } from "./from-employee.vue?vue&type=template&id=9ef69244&scoped=true&"
import script from "./from-employee.vue?vue&type=script&lang=js&"
export * from "./from-employee.vue?vue&type=script&lang=js&"
import style0 from "./from-employee.vue?vue&type=style&index=0&id=9ef69244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef69244",
  null
  
)

export default component.exports